<template>
<header>
    <div class="navbar">
        <h1 v-if="!isMobile" class="logo" @click="goToMainPage">AnimaTheraPro</h1>
        <nav>
            <ul style="display: flex; align-items: center; height: 100%;">
              <li v-if="initials === ''" id="user-details-icon" @click="detailUser" data-cy="user-details"><font-awesome-icon icon="user-gear"/></li>
              <li v-else id="user-details-initials" @click="detailUser" data-cy="user-details">{{ initials }}</li>
              <li @click="logout" class="pointer" data-cy="logout">Se déconnecter</li>
            </ul>
        </nav>
    </div>
</header>   
</template>

<script>

export default ({
  name: 'ProHeaderLoggedIn',
  data() {
      return {
        isMobile: this.$store.state.isMobile,
        initials : ""
      }
  },
  methods : {
      goToMainPage() {
          this.$router.push('/pros/sessions')
      },
      detailUser() {
        this.$router.push('/pros/user')
      },
      logout(e) {
        e.preventDefault()
        this.$store.dispatch('logout').then( 
            () => {
                localStorage.removeItem('jwtToken')
                this.$router.push('/')
            }
        )
      }
  },
  mounted () {
    this.unwatchUser = this.$store.watch(
      (state) => state.user,
      (newUser) => {
        if (newUser && newUser.firstname && newUser.lastname) {
            this.initials = newUser.firstname.charAt(0).toUpperCase() + newUser.lastname.charAt(0).toUpperCase()
        } else {
            this.initials = ""
        }
      }
    )
  }
})
</script>
<style scoped>
#user-details-icon {
    cursor: pointer;
    font-size: 22px;
}
#user-details-initials {
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
  color: white;
  background-color: darkgrey;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--anima-secondary-color);
  box-sizing: border-box;
}
</style>